import { PlacementMode } from './PlacementSystem';

export interface UndoAction {
  undo: () => void;
  redo: () => void;
  mode: PlacementMode;
  kind: 'remove' | 'restore';
}

export class UndoManager {
  private undoStack: UndoAction[] = [];
  private redoStack: UndoAction[] = [];

  public push(action: UndoAction): void {
    this.undoStack.push(action);
    this.redoStack = [];
  }

  public undo(): UndoAction | undefined {
    const action = this.undoStack.pop();
    if (!action) {
      return undefined;
    }

    this.redoStack.push(action);
    return action;
  }

  public redo(): UndoAction | undefined {
    const action = this.redoStack.pop();
    if (!action) {
      return undefined;
    }

    this.undoStack.push(action);
    return action;
  }

  public clear(): void {
    this.undoStack = [];
    this.redoStack = [];
  }
}
